export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangePortalOwner.json?hash=2046b027b79a89cec43011df5c3ad14d";